import SimpleParallax from "simple-parallax-js";

var images = document.querySelectorAll(".parallax-img");
new SimpleParallax(images, {
  delay: 0,
  orientation: "down",
  scale: 1.3,
  overflow: false,
});
